// src/api.js
// Helper for frontend API calls to backend


export async function fetchShippingRate(zip, packs = 1) {
  const res = await fetch("/api/shipping-rate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ zip, packs })
  });
  if (!res.ok) throw new Error("Failed to fetch shipping rate");
  return res.json();
}

export async function createCheckoutSession({ product, packs, shippingZip, coupon }) {
  const res = await fetch("/api/create-checkout-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ product, packs, shippingZip, coupon })
  });
  if (!res.ok) throw new Error("Failed to create checkout session");
  return res.json();
}
